import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import ArrowIcon from "../manufacturer-level-coverage/images/arrow.svg";
import OrangeTick from "./images/orange-tick.svg";
import { NUMBER } from "../../../../constants/app-constants";

const ComprehensiveServiceCheck = ({ onModalOpen, benefits  }) => {
    const { title = "", items = [], pointers = [] } = benefits || {};

    if (!title) return null;

    return (
        <div styleName="styles.outer">
            <div styleName="styles.contentWrapper">
                {/* Title Section */}
                <div styleName="styles.titleSection">
                    <h2 styleName="styles.heading">{title}</h2>
                </div>

                <div styleName="styles.featureContainer">
                    {items?.length > 0 &&
                     items?.slice(0, NUMBER.THREE).map((item, index) => (
                         <div styleName="styles.featureItem" key={index}>
                             <img src={item?.iconUrl} alt="Mechanic" />
                             <p styleName={"styles.featureText"}>{item?.info}</p>
                         </div>
                     ))}
                    <div onClick={onModalOpen} styleName="styles.moreInfoDiv">
                        & much more
                    </div>
                </div>

                {/* Modal Button */}
                <div styleName="styles.list">
                    {pointers?.length > 0 && pointers?.map((el, index) => (
                        <div key={index} styleName="styles.listItem">
                            <img src={OrangeTick} alt="Orange Tick" />
                            <p styleName={"styles.listText"}>{el?.info}</p>
                        </div>
                    ))}
                    <button styleName="styles.actionButton styles.button" onClick={onModalOpen}>
                        More about CARS24 Servicing
                        <img src={ArrowIcon} alt="Arrow Icon" />
                    </button>
                </div>
            </div>
        </div>
    );
};

ComprehensiveServiceCheck.propTypes = {
    onModalOpen: PropTypes.func,
    benefits: PropTypes.array
};

export default ComprehensiveServiceCheck;
